import React, { Component, useEffect } from 'react';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';

import Body from '../Components/layout/Body';
import './Views.scss';

const PAST_HELP = `
  <div>
    <p><strong>Purpose:</strong> Past access methods are those that the client has used or tried in the past but does not use currently.  
    For example, if a client has complex needs, other AT teams may have already tried a variety of access methods, with varied results.  
    </p>
    <p>If the client has a long history with alternative access, you don’t necessarily need to include every single past access method.  
    But it can be useful to understand things that have been tried and were not a good fit.  
    </p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  currentMethods: PropTypes.arrayOf(PropTypes.string), //TODO change to object array eventually
  onAddMethod: PropTypes.func.isRequired,
  onDeleteMethod: PropTypes.func.isRequired,
  onEditMethod: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
  currentMethods: []
};

//content sub-component with unique content for this page
class HistoryPastMethodsReviewContent extends Component {

  edit(index){
    this.props.onEditMethod(index);
  }
  delete(index){
    this.props.onDeleteMethod(index);
  }

  //Render the view for current methods.
  render(){
    const pastMethods = this.props.pastMethods; //TODO more complex
    const onAddMethod = this.props.onAddMethod;
    
    //show a table listing the currentMethods
    return(
    <>
      <Row>
        <Col>
          {pastMethods.map((item, index) =>
          <Row key={index} className="aa-review-row border-top">
            <Col>
              {item.name}
            </Col>
            <Col>
              <Button className="aa-inner-button float-right" color="secondary" outline onClick={this.edit.bind(this,index)}> Edit </Button>
              <Button className="aa-inner-button float-right" color="secondary" outline onClick={this.delete.bind(this,index)}> Delete </Button>
            </Col>
          </Row>
          )}  
        </Col>
        <Col lg={2}></Col>
      </Row>
      <Row className="aa-review-row">
        <Col>
          <Button onClick={onAddMethod}>Add a method</Button>  
        </Col>
      </Row>
    </>
    );
  }
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function GatherInfoHistoryPastMethodsReview(props) {
  const firstName = props.firstName;
  const pastMethods = props.pastMethods;
  const onAddMethod = props.onAddMethod;
  const onEditMethod = props.onEditMethod;
  const onDeleteMethod = props.onDeleteMethod;
  const savePastMethods = props.savePastMethods;
  const onContinue = props.onContinue;

  console.log("rendering GatherInfoHistoryPastMethodsReview");

  const pageDataNoMethods = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-clock-o",
    pageSymbolClassName: "aa-section-symbol gather",

    title: `What alternative access methods has ${firstName} tried in the past, if any?`,
    subTitle: "Enter what's been tried in the last year or so. If there are none, just Continue, to skip this question.",
    learnMore: {linkText: "Learn More about what access AT history is and why we're asking",
                title: "Past Access Methods",
                content: PAST_HELP
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }

  const pageDataMethods = {
    image: "./assets/images/target-icon.jpg", //not yet used
    faIcon: "fa-clock-o",
    pageSymbolClassName: "aa-section-symbol gather",
    title: `Review ${firstName}'s past access methods`,
    subTitle: "Here's what you've entered so far.",
    learnMore: {linkText: "Learn More about what access AT history is and why we're asking",
                title: "Past Access Methods",
                content: "Here is more info about Past Access Methods."
                },
    nextRoute: "", //not used since we have an onContinue callback
    sidebar: true
  }

  //Save the current methods to the App state whenever this component unmounts
  //For this component, this happens on: 
  //navigation with buttons (Back, Continue) or tabs (a new section)
  //click Add a Method to add a new method -- this save is redundant but not wrong
  //click Edit to edit an existing method. -- this save is redundant but not wrong
  useEffect(() => {
    console.log('GIHPastReview mounted');
    return () => {
      console.log('GIHPastReview unmounting and saving...');
      savePastMethods();
    }
  }, [savePastMethods])

  return(
    <>
    <Body page={(pastMethods.length === 0) ? pageDataNoMethods : pageDataMethods} 
      contentComponent={
        <HistoryPastMethodsReviewContent 
          pastMethods={pastMethods}
          onAddMethod={onAddMethod}
          onEditMethod={onEditMethod}
          onDeleteMethod={onDeleteMethod}
      />
      }
      onContinue={onContinue} 
    />
    </>
  );
}

GatherInfoHistoryPastMethodsReview.propTypes = propTypes;
GatherInfoHistoryPastMethodsReview.defaultProps = defaultProps;

export default GatherInfoHistoryPastMethodsReview;